import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';
import { DATE_FORMAT } from 'const';
import Styles from './DatePicker.module.css';

const { RangePicker } = DatePicker;

const DatePickerMain = ({ value, ...props }) => {
  const dayjsValue = value ? dayjs(value) : null;

  return (
    <DatePicker
      format={DATE_FORMAT}
      className={Styles.datePicker}
      value={dayjsValue}
      {...props}
    />
  );
};

DatePickerMain.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const RangePickerMain = ({ value, className, ...props }) => {
  const dayjsValues =
    value && Array.isArray(value)
      ? value.map((v) => (v ? dayjs(v) : null))
      : null;

  return (
    <RangePicker
      format={DATE_FORMAT}
      className={cn(Styles.datePicker, className)}
      value={dayjsValues}
      separator="-"
      {...props}
    />
  );
};

RangePickerMain.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
};

export { DatePickerMain as DatePicker, RangePickerMain as RangePicker };
